module.exports = __webpack_public_path__ + "img/hkht_bd.a6eeb68.png";